import { useState, useRef, useEffect } from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  resultsCount: number;
  totalCount: number;
  isMobile?: boolean;
  onBack?: () => void;
}

export default function SearchBar({ value, onChange, onClear, resultsCount, totalCount, isMobile, onBack }: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (isMobile && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isMobile]);

  return (
    <div className={`w-full ${isMobile ? '' : 'max-w-2xl'}`}>
      <div className="relative flex items-center gap-3">
        {isMobile && onBack && (
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer shrink-0"
          >
            <i className="ri-arrow-left-line text-xl text-foreground-700"></i>
          </button>
        )}
        <div
          className={`relative flex-1 flex items-center gap-3 px-4 h-12 rounded-xl transition-all duration-200 ${
            focused
              ? 'bg-background-50 ring-2 ring-primary-500/30'
              : 'bg-background-100 hover:bg-background-200/60'
          }`}
        >
          <i className={`ri-search-line text-lg transition-colors duration-200 ${focused ? 'text-primary-500' : 'text-foreground-400'}`}></i>
          <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder="Buscar por nombre, frecuencia, ciudad, país, categoría, idioma o locutor..."
            className="flex-1 bg-transparent border-none outline-none text-sm text-foreground-950 placeholder:text-foreground-400"
            autoComplete="off"
          />
          {value && (
            <button
              onClick={onClear}
              className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-200 hover:bg-foreground-300 transition-colors cursor-pointer shrink-0"
            >
              <i className="ri-close-line text-xs text-foreground-600"></i>
            </button>
          )}
        </div>
      </div>
      {value && (
        <p className="mt-2 text-xs text-foreground-500 pl-1">
          {resultsCount} de {totalCount} radios encontradas
        </p>
      )}
    </div>
  );
}